/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextField,
} from "@aws-amplify/ui-react";
import { IndustryMetric } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function IndustryMetricCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    Metric: "",
    MetricValue: "",
    MetricUnitOfMeasure: "",
    MetricCode: "",
    DisclosureCode: "",
    DisclosureTopic: "",
    DiscussionAnalysis: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [Metric, setMetric] = React.useState(initialValues.Metric);
  const [MetricValue, setMetricValue] = React.useState(
    initialValues.MetricValue
  );
  const [MetricUnitOfMeasure, setMetricUnitOfMeasure] = React.useState(
    initialValues.MetricUnitOfMeasure
  );
  const [MetricCode, setMetricCode] = React.useState(initialValues.MetricCode);
  const [DisclosureCode, setDisclosureCode] = React.useState(
    initialValues.DisclosureCode
  );
  const [DisclosureTopic, setDisclosureTopic] = React.useState(
    initialValues.DisclosureTopic
  );
  const [DiscussionAnalysis, setDiscussionAnalysis] = React.useState(
    initialValues.DiscussionAnalysis
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setMetric(initialValues.Metric);
    setMetricValue(initialValues.MetricValue);
    setMetricUnitOfMeasure(initialValues.MetricUnitOfMeasure);
    setMetricCode(initialValues.MetricCode);
    setDisclosureCode(initialValues.DisclosureCode);
    setDisclosureTopic(initialValues.DisclosureTopic);
    setDiscussionAnalysis(initialValues.DiscussionAnalysis);
    setErrors({});
  };
  const validations = {
    Metric: [],
    MetricValue: [],
    MetricUnitOfMeasure: [],
    MetricCode: [],
    DisclosureCode: [],
    DisclosureTopic: [],
    DiscussionAnalysis: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Metric,
          MetricValue,
          MetricUnitOfMeasure,
          MetricCode,
          DisclosureCode,
          DisclosureTopic,
          DiscussionAnalysis,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new IndustryMetric(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "IndustryMetricCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Industry Metric"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 21b."
        {...getOverrideProps(overrides, "SectionalElement00")}
      ></Heading>
      <Text
        children="Create a record that describes an industry-based metric relevant to your industry or business model used to measure and manage climate-related risks and opportunities."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Metric"
        isRequired={false}
        isReadOnly={false}
        value={Metric}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Metric: value,
              MetricValue,
              MetricUnitOfMeasure,
              MetricCode,
              DisclosureCode,
              DisclosureTopic,
              DiscussionAnalysis,
            };
            const result = onChange(modelFields);
            value = result?.Metric ?? value;
          }
          if (errors.Metric?.hasError) {
            runValidationTasks("Metric", value);
          }
          setMetric(value);
        }}
        onBlur={() => runValidationTasks("Metric", Metric)}
        errorMessage={errors.Metric?.errorMessage}
        hasError={errors.Metric?.hasError}
        {...getOverrideProps(overrides, "Metric")}
      ></TextField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid5")}
      >
        <TextField
          label="Metric value"
          isRequired={false}
          isReadOnly={false}
          value={MetricValue}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                Metric,
                MetricValue: value,
                MetricUnitOfMeasure,
                MetricCode,
                DisclosureCode,
                DisclosureTopic,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.MetricValue ?? value;
            }
            if (errors.MetricValue?.hasError) {
              runValidationTasks("MetricValue", value);
            }
            setMetricValue(value);
          }}
          onBlur={() => runValidationTasks("MetricValue", MetricValue)}
          errorMessage={errors.MetricValue?.errorMessage}
          hasError={errors.MetricValue?.hasError}
          {...getOverrideProps(overrides, "MetricValue")}
        ></TextField>
        <TextField
          label="Metric unit of measure"
          isRequired={false}
          isReadOnly={false}
          value={MetricUnitOfMeasure}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                Metric,
                MetricValue,
                MetricUnitOfMeasure: value,
                MetricCode,
                DisclosureCode,
                DisclosureTopic,
                DiscussionAnalysis,
              };
              const result = onChange(modelFields);
              value = result?.MetricUnitOfMeasure ?? value;
            }
            if (errors.MetricUnitOfMeasure?.hasError) {
              runValidationTasks("MetricUnitOfMeasure", value);
            }
            setMetricUnitOfMeasure(value);
          }}
          onBlur={() =>
            runValidationTasks("MetricUnitOfMeasure", MetricUnitOfMeasure)
          }
          errorMessage={errors.MetricUnitOfMeasure?.errorMessage}
          hasError={errors.MetricUnitOfMeasure?.hasError}
          {...getOverrideProps(overrides, "MetricUnitOfMeasure")}
        ></TextField>
      </Grid>
      <TextField
        label="Metric code"
        isRequired={false}
        isReadOnly={false}
        value={MetricCode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              MetricCode: value,
              DisclosureCode,
              DisclosureTopic,
              DiscussionAnalysis,
            };
            const result = onChange(modelFields);
            value = result?.MetricCode ?? value;
          }
          if (errors.MetricCode?.hasError) {
            runValidationTasks("MetricCode", value);
          }
          setMetricCode(value);
        }}
        onBlur={() => runValidationTasks("MetricCode", MetricCode)}
        errorMessage={errors.MetricCode?.errorMessage}
        hasError={errors.MetricCode?.hasError}
        {...getOverrideProps(overrides, "MetricCode")}
      ></TextField>
      <TextField
        label="Disclosure code"
        isRequired={false}
        isReadOnly={false}
        value={DisclosureCode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              MetricCode,
              DisclosureCode: value,
              DisclosureTopic,
              DiscussionAnalysis,
            };
            const result = onChange(modelFields);
            value = result?.DisclosureCode ?? value;
          }
          if (errors.DisclosureCode?.hasError) {
            runValidationTasks("DisclosureCode", value);
          }
          setDisclosureCode(value);
        }}
        onBlur={() => runValidationTasks("DisclosureCode", DisclosureCode)}
        errorMessage={errors.DisclosureCode?.errorMessage}
        hasError={errors.DisclosureCode?.hasError}
        {...getOverrideProps(overrides, "DisclosureCode")}
      ></TextField>
      <TextField
        label="Disclosure topic"
        isRequired={false}
        isReadOnly={false}
        value={DisclosureTopic}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              MetricCode,
              DisclosureCode,
              DisclosureTopic: value,
              DiscussionAnalysis,
            };
            const result = onChange(modelFields);
            value = result?.DisclosureTopic ?? value;
          }
          if (errors.DisclosureTopic?.hasError) {
            runValidationTasks("DisclosureTopic", value);
          }
          setDisclosureTopic(value);
        }}
        onBlur={() => runValidationTasks("DisclosureTopic", DisclosureTopic)}
        errorMessage={errors.DisclosureTopic?.errorMessage}
        hasError={errors.DisclosureTopic?.hasError}
        {...getOverrideProps(overrides, "DisclosureTopic")}
      ></TextField>
      <TextField
        label="Discussion analysis"
        isRequired={false}
        isReadOnly={false}
        value={DiscussionAnalysis}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Metric,
              MetricValue,
              MetricUnitOfMeasure,
              MetricCode,
              DisclosureCode,
              DisclosureTopic,
              DiscussionAnalysis: value,
            };
            const result = onChange(modelFields);
            value = result?.DiscussionAnalysis ?? value;
          }
          if (errors.DiscussionAnalysis?.hasError) {
            runValidationTasks("DiscussionAnalysis", value);
          }
          setDiscussionAnalysis(value);
        }}
        onBlur={() =>
          runValidationTasks("DiscussionAnalysis", DiscussionAnalysis)
        }
        errorMessage={errors.DiscussionAnalysis?.errorMessage}
        hasError={errors.DiscussionAnalysis?.hasError}
        {...getOverrideProps(overrides, "DiscussionAnalysis")}
      ></TextField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
